// Fallback only. Runtime version should come from GET /v1/config/legal.
export const LEGAL_TERMS_VERSION = '2026-03-02-hk-v1'

export const LEGAL_ROUTES = {
  userAgreement: '/legal/user-agreement',
  privacyPolicy: '/legal/privacy-policy',
  disclaimer: '/legal/disclaimer',
  acceptableUsePolicy: '/legal/acceptable-use-policy',
} as const

